export const LOADING_MESSAGE = Object.freeze({
  default: '잠시만 기다려주세요',
  getMonthlyAttendanceHistory: '출석 이력 불러오는 중...',
  downloadExamReview: '다운로드 중...',
});
